export default {"src":"/_next/static/media/info.5f70fca6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};